module.exports = __webpack_public_path__ + "static/media/starbigy.581128ed.png";